export type ChatSessionSummary = {
  sessionId: string;
  title: string | null;
  createdAt: string;
  hasTerminatedTurn?: boolean;
  userName?: string | null;
  domainName?: string | null;
};

export type ChatSessionListResponse = {
  sessions: Array<{
    session_id: string;
    title: string | null;
    created_at: string;
    has_terminated_turn?: boolean;
    user_name?: string | null;
    domain_name?: string | null;
  }>;
};

export type UpdateChatTitleResponse = {
  session_id: string;
  title: string | null;
  created_at: string;
};

export function mapChatSessionSummary(
  item: ChatSessionListResponse["sessions"][number],
): ChatSessionSummary {
  return {
    sessionId: item.session_id,
    title: item.title,
    createdAt: item.created_at,
    hasTerminatedTurn: Boolean(item.has_terminated_turn),
    userName: item.user_name ?? null,
    domainName: item.domain_name ?? null,
  };
}
